<template>
    <div class="autocomplete">
        <label v-if="showLabel">Tiers</label>
        <b-input-group>
            <b-input-group-prepend>
                <b-button
                    key="cancelButton"
                    title="Annuler la recherche"
                    @click="hide"
                >
                    <i class="fas fa-fw fa-times"></i>
                </b-button>
            </b-input-group-prepend>
            <b-form-input
                ref="searchInput"
                v-model="search"
                type="text"
                placeholder="Saisissez le nom du client recherché"
                size="lg"
                :state="!noResult"
                @update="onChange"
            />
        </b-input-group>
        <ul
            v-show="isOpen"
            id="autocomplete-results"
            class="autocomplete-results"
        >
            <li v-if="isLoading" class="loading">
                <i class="fas fa-spinner" spin></i>
                Recherche en cours
            </li>
            <li
                v-for="(client, i) in clients"
                v-if="!isLoading"
                :key="i"
                class="autocomplete-result"
                :class="{ 'is-active': i === arrowCounter }"
                @click="setClient(client)"
            >
                {{ clientDetails(client) }}
            </li>
        </ul>
    </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators'

export default {
    name: 'SearchClientBig',

    props: {
        size: '',
        showLabel: true,
    },

    data() {
        return {
            isOpen: false,
            clients: [],
            clientId: '',
            search: '',
            isLoading: false,
            arrowCounter: 0,
            hasResult: false,
            ErrorFeedback: {
                required: 'Champ obligatoire',
            },
        }
    },

    validations: {
        search: {
            required,
        },
    },

    computed: {
        noResult() {
            return this.search.length >= 2 && this.clients.length === 0
        },
    },

    methods: {
        hide() {
            this.$emit('hide-me')
        },

        onChange() {
            this.getClients()
            this.$emit('searching-client')
        },

        async getClients() {
            if (this.search.length >= 2) {
                try {
                    this.hasResult = false
                    this.isOpen = true
                    this.isLoading = true
                    const response = await axios.get(
                        `/clients/search/${this.search}`
                    )
                    this.clients = response.data.data
                    this.isLoading = false
                } catch (error) {
                    // handle error
                    console.log(error)
                }
            } else {
                this.clients = []
            }
            this.checkResults()
        },

        clientDetails(client) {
            return client.name
        },

        setClient(client) {
            console.log('client: ', client)
            this.search = this.clientDetails(client)
            this.$emit('client-is-set', client)
            this.isOpen = false
            this.hasResult = true
        },

        checkResults() {
            if (this.noResult) {
                this.isOpen = false
            }
        },
    },
}
</script>

<style scoped>
.autocomplete {
    position: relative;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 150px;
    overflow: auto;
    background-color: #fff;
}

.autocomplete-result {
    font-size: 16px;
    list-style: none;
    text-align: left;
    padding: 4px 12px;
    cursor: pointer;
}

.autocomplete-result:hover {
    background-color: #98be12;
    color: #ffffff;
}

.loading {
    list-style: none;
    text-align: center;
    padding: 0;
    cursor: none;
    margin-top: 20px;
}
</style>
